import React from 'react'
import { View, FlatList, ViewStyle, TextStyle } from 'react-native'
import { Header, color, iconArrowBack, RadioGroupWeb as RadioGroup } from '@trivie/ui-mobile'
import { useTranslation } from 'react-i18next'
import { useStores, save } from '@trivie/core'

import { useHistory } from 'react-router'

const languages = [
  { id: 0, locale: 'en', label: 'English' },
  // { id: 1, locale: 'ar', label: 'العربية' },
  // { id: 2, locale: 'ja', label: '日本語' },
  // { id: 3, locale: 'de', label: 'Deutsche' },
  { id: 4, locale: 'es', label: 'Español' },
  { id: 5, locale: 'fr', label: 'Français' },
  { id: 6, locale: 'fr-CA', label: 'Français (CA)' },
  { id: 7, locale: 'it', label: 'Italian' },
  // { id: 8, locale: 'ko', label: '한국어 | 韓國語' },
  // { id: 9, locale: 'pt-BR', label: 'Português' },
  // { id: 10, locale: 'ru', label: 'Русский' },
  // { id: 11, locale: 'zh-Hans', label: '简体中文' },
  // { id: 12, locale: 'zh-Hant', label: '繁體中文' },
]

export const LanguageScreen = () => {
  const history = useHistory()
  const goBack = () => history.goBack()

  const { userStore } = useStores()
  const { user } = userStore

  const { i18n } = useTranslation()

  return (
    <View style={FULL}>
      <div style={CONTAINER}>
        <Header
          leftIcon={iconArrowBack}
          onLeftPress={goBack}
          center
          titleStyle={HEADER}
          headerTx="Settings.Language"
        />
        <FlatList
          extraData={user?.language}
          data={languages}
          keyExtractor={(item) => item.id.toString()}
          renderItem={({ item }) => (
            <RadioGroup
              onPress={() => {
                save('locale', item.locale)
                i18n.changeLanguage(item.locale)
                userStore.setLanguage(item.locale)
              }}
              options={[{ label: item.label, value: item.locale }]}
              value={user?.language || 'en'}
            />
          )}
        />
      </div>
    </View>
  )
}

/**
 * Styling
 */
const FULL: ViewStyle = { flex: 1 }
const CONTAINER: React.CSSProperties = {
  backgroundColor: color.white,
}
const HEADER: TextStyle = { fontSize: 24, color: color.black }
